import {
  getSessionStorage,
  setSessionStorage,
} from '@mr-yum/frontend-core/dist/support/env'

const tappedOnKey = 'isTappedOn'

export const setGuestTappedOn = () => {
  setSessionStorage(tappedOnKey, 'true')
}

export const clearGuestTappedOn = () => {
  setSessionStorage(tappedOnKey, 'false')
}

export const isGuestTappedOn = () => {
  return getSessionStorage(tappedOnKey) === 'true'
}
